{
  "id": "ncm",
  "nome": "NCM — Nomenclatura Comum do Mercosul",
  "fonte": "Receita Federal / Siscomex nomenclatura JSON",
  "endpoints": [
    "https://portalunico.siscomex.gov.br/classif/api/publico/nomenclatura/download/json?perfil=PUBLICO"
  ],
  "capturadoEm": "2026-08-05",
  "atualizadoEm": "2026-08-05T06:10:41.913Z",
  "contagens": {
    "ncm": 10515
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-08-04"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-05T06:10:41.913Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#ncm-mercosur-nomenclature"
}
